import { Card, Grid, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { Api_Token } from "../../env";
import BurstModeIcon from "@mui/icons-material/BurstMode";
import PhotoLibraryIcon from "@mui/icons-material/PhotoLibrary";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";

export const CardDataButton = ({ data }) => {
  return (
    <Card sx={{ padding: "8%", borderRadius: "5%" }}>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <Grid container>
            <Grid item xs={12}>
              <Typography sx={{ color: "gray", fontSize: "13px" }}>
                {data.titre}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography>{data.Number}</Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid
          item
          xs={6}
          sx={{
            display: "flex",
            justifyContent: "right",
            alignItems: "center",
          }}
        >
          {data.icon}
        </Grid>

        <Grid item xs={12} textAlign="center">
          <Link to={data.linkSousText} style={{ textDecoration: "none" }}>
            <Typography
              sx={{
                fontSize: "15px",
                color: "#064C91",
                textDecoration: "underline",
              }}
            >
              {data.linkSousText !== "" ? data.soustext : ""}
            </Typography>
          </Link>
        </Grid>
      </Grid>
    </Card>
  );
};

export const CardDataSimple = ({ data }) => {
  return (
    <Card sx={{ padding: "8%", borderRadius: "5%", height: "100%" }}>
      <Grid container spacing={2}>
        <Grid item xs={12} textAlign="center"></Grid>
        <Grid item xs={6}>
          <Grid container>
            <Grid item xs={12}>
              <Typography variant="h6">
                <b>
                  {data.Number} {data.titre}
                </b>
              </Typography>
            </Grid>
            {/** <Grid item xs={12}>
              <Typography>{data.Number}</Typography>
            </Grid>*/}
          </Grid>
        </Grid>
        <Grid
          item
          xs={6}
          sx={{
            display: "flex",
            justifyContent: "right",
            alignItems: "center",
          }}
        >
          {data.icon}
        </Grid>
        <Grid item xs={12}></Grid>

        <Grid item xs={12} textAlign="center">
          <Link to={data.linkSousText} style={{ textDecoration: "none" }}>
            <Typography
              sx={{
                fontSize: "15px",
                color: "#064C91",
                textDecoration: "underline",
              }}
            >
              {data.linkSousText !== "" ? data.soustext : ""}
            </Typography>
          </Link>
        </Grid>
      </Grid>
    </Card>
  );
};

export function NumberGeneralEvent() {
  //  const { StatistiqueGeneral } = useSelector((state) => state.Statistique);
  //  const { user } = useSelector((state) => state.AuthSlice);
  const [StatistiqueGeneral, setStatistiqueGeneral] = useState({});
  useEffect(() => {
    Api_Token.get(`/command/GetStatistiqueDashboardEvent`)
      .then((response) => {
        setStatistiqueGeneral(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const Data = [
    {
      titre: "Commandes",
      icon: <BurstModeIcon fontSize="large" color="primary" />,
      Number: StatistiqueGeneral?.commandCount ?? 0,
    },
    {
      titre: "Images totales",
      icon: <BurstModeIcon fontSize="large" color="primary" />,
      Number: StatistiqueGeneral?.imageCount ?? 0,
    },
    {
      titre: "Images imprimées",
      icon: <PhotoLibraryIcon fontSize="large" color="primary" />,
      Number: StatistiqueGeneral?.totalImageImprime ?? 0,
    },
    {
      titre: "Montant total",
      icon: <AttachMoneyIcon fontSize="large" color="primary" />,
      Number: `${StatistiqueGeneral?.Prix ?? 0} DH`,
    },
  ];

  return (
    <Grid container spacing={2}>
      {Data.map((d) => (
        <Grid item md={3} xs={6}>
          <CardDataSimple data={d} />
        </Grid>
      ))}
    </Grid>
  );
}

function NumberGeneral({ DateRange }) {
  //  const { StatistiqueGeneral } = useSelector((state) => state.Statistique);
  //  const { user } = useSelector((state) => state.AuthSlice);
  const [StatistiqueGeneral, setStatistiqueGeneral] = useState({});
  useEffect(() => {
    const startDate =
      DateRange?.startDate ||
      new Date(new Date().setDate(new Date().getDate() - 7));
    const endDate = DateRange?.endDate || new Date();

    Api_Token.get(
      `/command/GetStatistiqueDashboard?startDate=${
        startDate.toISOString().split("T")[0]
      }&endDate=${endDate.toISOString().split("T")[0]}`
    )
      .then((response) => {
        setStatistiqueGeneral(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [DateRange]);
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat("fr-MA", {
      style: "currency",
      currency: "MAD",
      minimumFractionDigits: 0,
    }).format(amount || 0);
  };

  const Data = [
    {
      titre: "Commandes totales",
      icon: <BurstModeIcon fontSize="large" color="primary" />,
      Number: StatistiqueGeneral?.commandCount ?? 0,
    },
    {
      titre: "Commandes annulées",
      icon: <BurstModeIcon fontSize="large" color="primary" />,
      Number: StatistiqueGeneral?.commandAnnule ?? 0,
    },
    {
      titre: "Commandes payées",
      icon: <PhotoLibraryIcon fontSize="large" color="primary" />,
      Number: StatistiqueGeneral?.commandPaye ?? 0,
    },
    {
      titre: "Montant total",
      icon: <AttachMoneyIcon fontSize="large" color="primary" />,
      Number: formatCurrency(StatistiqueGeneral?.Prix),
    },
  ];

  return (
    <Grid container spacing={2}>
      {Data.map((d) => (
        <Grid item md={3} xs={6}>
          <CardDataSimple data={d} />
        </Grid>
      ))}
    </Grid>
  );
}

export default NumberGeneral;
